/**
 * Project panel
 *
 * Created by stefensuhat on 11/08/18 3.19 PM
 */

import { api, apiv2 } from 'utils';

const defaultState = {
    items: [],
    item: {},
    meta: { total: 0, per_page: 25, current_page: 1 },
    types: [],
    approved: false,
    errors: null,
    statistic: {},
};

export default {
    state: defaultState,
    reducers: {
        reset: (state) => ({ ...state, ...defaultState }),
        fetchResponse: (state, payload) => ({
            ...state,
            items: payload.data,
            meta: payload.meta,
            types: payload.types,
        }),
        findResponse: (state, payload) => ({ ...state, item: payload.data }),
        approveResponse: (state, payload) => {
            if (payload.errors) {
                return { ...state, errors: payload.errors };
            }

            return { ...state, errors: null, approved: true };
        },
        statisticsResponse: (state, payload) => ({
            ...state, statistic: payload.data,
        }),
    },
    effects: {
        async fetch(params) {
            await api.get('transactions', { params })
                .then((response) => this.fetchResponse(response));
        },

        async find(id) {
            await apiv2.get(`transactions/${id}`)
                .then((response) => this.findResponse(response));
        },

        async approve(data) {
            await api.post(`transactions/${data.id}/approve`, data)
                .then((response) => this.approveResponse(response));
        },

        async fetchStatistics(params) {
            await apiv2.get('transactions/report', { params })
                .then((response) => this.statisticsResponse(response));
        },
    },
    selectors: (slice, createSelector) => ({
        all() {
            return createSelector(slice, (state) => state.transaction, (transactions) => transactions.items);
        },
        select2() {
            return createSelector(this.all, (state) => state.items, (transactions) => {
                const array = [];
                transactions.map((transaction) => array.push({ label: transaction.id, value: transaction.id }));

                return array;
            });
        },
        find() {
            return createSelector(
                this.all,
                (state, selectedId) => selectedId,
                (transactions, selectedId) => transactions.find((transaction) => transaction.id === selectedId),
            );
        },
    }),
};
